import React from 'react';
import { IMPUESTOS } from '../services/facturasService';

// Impuesto del producto para la factura con CAI (sql/094). Por defecto 15 %.
export default function SelectorImpuesto({ valor, onChange, deshabilitado }) {
  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={{ display: 'block', fontWeight: 600, fontSize: '14px', marginBottom: '6px', color: '#374151' }}>🧾 Impuesto (para la factura)</label>
      <select value={valor || 'g15'} disabled={deshabilitado} onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%', padding: '10px 12px', border: '1px solid #D1D5DB', borderRadius: '9px', fontSize: '15px', fontFamily: 'inherit', background: '#fff' }}>
        {IMPUESTOS.map((i) => <option key={i.valor} value={i.valor}>{i.etiqueta}</option>)}
      </select>
    </div>
  );
}
